import React from 'react';

interface IHeadersProps {
  filter: string;
}

const Level2Headers: React.FC<IHeadersProps> = ({ filter }) => {
  return (
    <div className='view-history-head-frame'>
      <div className='view-history-head-frame-cell'>
        <div className='view-history-head-frame-cell-cont'>
          <div className='view-history-head-frame-cell-cont-text'>{filter}</div>
        </div>
      </div>
      <div className='view-history-head-frame-cell'>
        <div className='view-history-head-frame-cell-cont'>
          <div className='view-history-head-frame-cell-cont-text'>
            Total Results
          </div>
        </div>
      </div>
      <div className='view-history-head-frame-cell'>
        <div className='view-history-head-frame-cell-cont'>
          <div className='view-history-head-frame-cell-cont-text'>
            New Results
          </div>
        </div>
      </div>
    </div>
  );
};

export default Level2Headers;
